import { DTIProvider } from './DTIProvider'

type DTIProviderServerProps = {
  children: React.ReactNode
  initialDataDti?: unknown
}

export function DTIProviderServer({ children, initialDataDti }: DTIProviderServerProps) {
  return <DTIProvider initialDataDti={initialDataDti}>{children}</DTIProvider>
}
